import { EgretLoadable } from "egret";
import ConstantList from "../../appConfig";
// const No01 = EgretLoadable({
//   loader: () => import("./No01"),
// });
// const No02 = EgretLoadable({
//   loader: () => import("./No02"),
// });
// const No03 = EgretLoadable({
//   loader: () => import("./No03"),
// });
// const No04 = EgretLoadable({
//   loader: () => import("./No04"),
// });
// const No05 = EgretLoadable({
//   loader: () => import("./No05"),
// });
// const No06 = EgretLoadable({
//   loader: () => import("./No06"),
// });
// const No07 = EgretLoadable({
//   loader: () => import("./ETB/Canvas/No07"),
// });
// const No08 = EgretLoadable({
//   loader: () => import("./ETB/Canvas/No08"),
// });
const No09= EgretLoadable({
  loader: () => import("./ETB/Canvas/No09"),
});
const No10 = EgretLoadable({
  loader: () => import("./ETB/Canvas/No10"),
});
const ReportNo12 = EgretLoadable({
  loader: () => import("./ETB/Canvas/ReportNo12"),
});
const ReportNo1201 = EgretLoadable({
  loader: () => import("./ETB/Canvas/ReportNo1201"),
});
const Routes = [
  // {
  //   path: ConstantList.ROOT_PATH + "report/no01",
  //   exact: true,
  //   component: No01,
  // },
  // {
  //   path: ConstantList.ROOT_PATH + "report/no02",
  //   exact: true,
  //   component: No02,
  // },
  // {
  //   path: ConstantList.ROOT_PATH + "report/no03",
  //   exact: true,
  //   component: No03,
  // },
  // {
  //   path: ConstantList.ROOT_PATH + "report/no04",
  //   exact: true,
  //   component: No04,
  // },
  // {
  //   path: ConstantList.ROOT_PATH + "report/no05",
  //   exact: true,
  //   component: No05,
  // },
  // {
  //   path: ConstantList.ROOT_PATH + "report/no06",
  //   exact: true,
  //   component: No06,
  // },
  // {
  //   path: ConstantList.ROOT_PATH + "report/no07",
  //   exact: true,
  //   component: No07,
  // },
  // {
  //   path: ConstantList.ROOT_PATH + "report/no08",
  //   exact: true,
  //   component: No08,
  // },
  {
    path: ConstantList.ROOT_PATH + "report/no09",
    exact: true,
    component: No09,
  },
  {
    path: ConstantList.ROOT_PATH + "report/no10",
    exact: true,
    component: No10,
  },
  {
    path: ConstantList.ROOT_PATH + "report/no12",
    exact: true,
    component: ReportNo12,
  },
  {
    path: ConstantList.ROOT_PATH + "report/no12-1",
    exact: true,
    component: ReportNo1201,
  },
];

export default Routes;
